import { createApp } from "vue";
import html from "./savethe.html";
import { dropzoneFile } from "../composant/dropezoneFile";
import hash from "../../hash";
import { B2bToast } from "../../B2bTools";
import Store from "../../Store";

function triSection(linelists) {
  const regroupements = {};
  for (const linelist of linelists) {
    const regroupement = linelist.regroupement || "test";

    if (!regroupements[regroupement]) {
      regroupements[regroupement] = { k: regroupement, rows: [] };
    }
    regroupements[regroupement].rows.push(linelist);
  }
  const array = [];
  for (const key in regroupements) {
    regroupements[key].rows.sort(function (a, b) {
      return (a.sortkey || "").localeCompare(b.sortkey);
    });
    array.push(regroupements[key]);
  }
  //
  array.sort(function (a, b) {
    return a.k.localeCompare(b.k);
  });
  return array;
}

const Etats = {
  rien: 0,
  errorStructure: 2,
  errorOrder: 3,
  orderOk: 4,
  done: 5,
};

const js = {
  url: function (echangeur) {
    
    //let u = Store.get('getURUL')();
    
    echangeur.addAction("b2b.SaveThe.list", echangeur.hash, "", "list");
    echangeur.addAction("b2b.env.get", echangeur.hash, "", "data");

  },
  onLoad: function (echangeur) {
    const THIS = this;
    const env = echangeur.data.env;




    const univers = echangeur.hash.u;

    //console.log(Store.get("CTX").session.profilName);
    let profil = Store.get("CTX").session.profilName;

    let profils = ["dmk-admin", "dmk-bda", "dmk-bd", "dmk-conception"];

    let editable = profils.indexOf(profil) > -1;
    let tocks = echangeur.data.tocs;


    for(let univer of echangeur.list.univers){
        univer.depv =  univer.v;
        let ord  = echangeur.list.ords[univer.k];
        if(ord && ord.orderdep)   univer.depv = ord.orderdep.v; 
    }
 



    const app = createApp({
      components: {
        "dropzone-file": dropzoneFile,
      },
      data() {
        const mains = env.linelists.filter((u) => !u.parent);

        return {
          tocs: tocks,
          environnement: {
            k: env.k,
            v: env.v,
            tocK: env.tocK,
            _id: env._id,
            sectionMains: triSection(mains),
          },
          list: echangeur.list,
          editable: editable,
          etat: Etats.rien,
          data: {},
          datas: [],
          market: "",
          Etats,
          orders: [], // tableau des commandes
          message: "", // un petit message décrivat l'état
          url: "", // lien vers download all errors.xlsx
          filename: "",
          erreurs: { messages: "" , aerr : []},
          options: {
            dep: [
              { k: "global", v: "Global" },
              { k: "WSHOES", v: "WSHOES" },
              { k: "MSHOES", v: "MSHOES" },
              { k: "KSHOES", v: "KSHOES" },
              { k: "MKTG", v: "MKTG" },
              { k: "BAGS-SLG", v: "BAGS-SLG" },
            ],
            ordertype: [{ k: "global", v: "Global" }],
            market: tocks.map((e) => ({ k: e._id, v: e.v })),
          },
          showDropzone: false,
        };
      },
      computed: {},

      methods: {
        openError(url) {
          if (url) window.open(url);
        },

        toV(value) {
          return (value || "no value").split("|").pop();
        },

        gotoRien() {
          this.etat = Etats.rien;
        },
        
        async launchMassImport(filename) {
          const retour = await THIS.rest("b2b.SaveThe.analyzeFile", {
            idToc:this.market,
            env:univers,
            filename: filename,
          });
          // @moche
          this.erreurs.explicit = [];

          if (retour.errors?.length === 0 && retour.warns?.length === 0) {
            this.datas = retour.data;
            this.etat = Etats.done;

            this.list = await THIS.rest("b2b.SaveThe.list", echangeur.hash);

            B2bToast("File imported", "success");
          } else {
            this.erreurs = {
              errorStructure: retour.errorStructure,
              messages: retour.errors?.[0].message || "Invalid Excel file",
            }
            
            this.erreurs.aerr = [];
            if(Array.isArray(retour.errors)) this.erreurs.aerr = retour.errors;

            //@moche => prévoir code erreur
            if (retour.errors?.[0].rownumber == 888) this.erreurs.explicit = retour.dataRefs;
              this.etat = Etats.errorStructure;

            B2bToast(`File not imported`, "error");
          }

       
        },

        async gotoDone() {
          const retour = await THIS.rest("b2b.SaveThe.analyzeFile", {
            idToc:this.market,

            filename: this.filename,
            writereal: true,
            etat: Etats.orderOk,
          });
          if (retour.done) {
            this.etat = Etats.done;
            this.orders = retour.orders;
          } else if (erreurs.errorStructure) {
            this.erreurs = retour.erreurs;
            this.etat = Etats.errorStructure;
          }
        },

        goToDetail(o) {
          hash.lance("savetheDetail", { k: o.k , orderepartement : o.orderdepartement, marketK: o.marketK,env:univers});
        },
      },
      watch: {
        async market(value) {
          if (value) {
            this.showDropzone = true;
          }else{
            this.showDropzone = false;
          }
        },
      },
    });

    this.vm = app.mount(THIS.c$("._vueChargement")[0]);
  },
  // reprise: async function (ecran) {

  // }
};

export default {
  savethe: { js: js, html: html },
};
